export const notSupportedCSSValues = Object.freeze(['inherit', 'unset', 'initial']);
